export enum PREFIX_KEY {
  GET = 'GET',
  POST = 'POST',
  FETCH = 'FETCH'
}

export const URL_ASSET = '/assets'
export const PRIMARY_QUERY_KEY_ASSETS = 'ASSETS'

export let confirmationStatus: 'warning' | 'primary' | 'success' | 'danger' | undefined
